"use strict";

import "./dialog-container-share.sass";
import angular from "angular";

class DialogContainerShareCtrl {
    constructor($mdDialog, $rootScope, locals, DSNDialogService, $filter) {
        this.$mdDialog = $mdDialog;
        this.$rootScope = $rootScope;
        this.locals = locals;
        this.DSNDialogService = DSNDialogService;
        this.companyData = locals.companyData;
        this.accountingId = locals.accountingId;
        this.report = locals.report;
    }
    $onInit() {}
}

angular
    .module("nucont")
    .controller("DialogContainerShareCtrl", [
        "$mdDialog",
        "$rootScope",
        "locals",
        "DSNDialogService",
        "$filter",
        DialogContainerShareCtrl
    ]);
